export default __webpack_public_path__ + "static/media/Sena.07838af6.png";